import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import { FileService } from "../../../../../../core/services/FileService";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../theme/Component/Modal";
import { Alert } from "../../../../../theme/Component/Alert";
import { MASK_BOOLEAN, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../../../theme/Component/BasicTable";
import { FileInput } from "../../../../../theme/Component/FileInput";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { DocumentPDF, DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { CurrencyEditor } from "../../../../../erp/cellEditor/Currency/CurrencyEditor";
import { UBLPayment } from "../../../../../contabilidad/CatalogoDocumentosUBL/UBLPayment/UBLPayment";
import { UBLInvoiceAdjustment } from "../../../../../contabilidad/CatalogoDocumentosUBL/UBLInvoiceAdjustment/UBLInvoiceAdjustment";
import { FireElectronicDocument } from "../FireElectronicDocument/FireElectronicDocument";
import { SelectUBLSoftwareDispatcherByEnvironmentType } from "../FireElectronicDocument/Selectores/SelectUBLSoftwareDispatcherByEnvironmentType";
import { UBLNotification } from "../UBLNotification/UBLNotification";
import { SelectAccountantConceptCatalogForSalesInvoice } from "../SelectAccountantConceptCatalogForSalesInvoice";
import { SelectAccountantConceptCatalogForSupplierInvoice } from "../SelectAccountantConceptCatalogForSupplierInvoice";
import { SelectUBLDocumentPaymentType } from "../CreateUBLInvoice/Components/SelectUBLDocumentPaymentType";
import { PrepaidPaymentEditor } from "../CreateUBLInvoice/ComponentPrepaidPayment/PrepaidPaymentEditor";
import { ReciablePaymentEditor } from "../CreateUBLInvoice/ComponentPrepaidPayment/ReciablePaymentEditor";
import { CreateUBLInvoiceItems } from "../CreateUBLInvoice/CreateUBLInvoiveItem";
import { AccountantDocumentList } from "../AccountantDocumentList/AccountantDocumentList";
import { HistoryUBLInvoice } from "../HistoryUBLInvoice";
import { SelectStoreEditor } from "../SelectStore.editor";
import { SelectSupplierPaymentTypeConstants } from "../../UBLInvoiceSupplier/Component/SelectSupplierPaymentTypeConstants";
import { UBLInvoiceItemSupplier } from "../../UBLInvoiceSupplier/Component/UBLInoviceItemSupplier/UBLInvoiceItemSupplier";
import { UBLInvoiceTaxSupplier } from "../../UBLInvoiceSupplier/Component/UBLInvoiceTax/UBLInvoiceTaxSupplier";
import { EditorUBLDiscrepancyResponse } from "../../UBLDiscrepancyResponse/EditorUBLDiscrepancyResponse";
import { SelectorUBLAdminFeeTypeConstants } from "../../UBLAdminFee/SelectorUBLAdminFeeTypeConstants";
import { UBLEventsInvoiceEmail } from "../../../../../contabilidad/CatalogoDocumentosUBL/UBLEventsInvoiceEmail/UBLEventsInvoiceEmail";

const PURCHASE_INVOICE = 0;
const BILL_OF_SALE = 1;
const BILL_OF_SALE_CONTINGENCY = 37;

export type UBLInvoiceActionKey =
    | "edit"
    | "items"
    | "withholdingTaxes"
    | "accountingDocuments"
    | "invoiceDocument"
    | "payments"
    | "events"
    | "crossPrepaid"
    | "applyPrepaid"
    | "contingency"
    | "setAsSale"
    | "proforma"
    | "description"
    | "accountantConcept"
    | "paymentTerms"
    | "currency"
    | "createAccounting"
    | "fireElectronicDocument"
    | "adjustmentNotes"
    | "radianEvents"
    | "duplicate"
    | "xml"
    | "notifyEmail"
    | "emailRep"
    | "notifySiif"
    | "fixedAssetEntry"
    | "invoiceAttachment"
    | "nullify"
    | "paymentType"
    | "accountingDocument"
    | "fixedAssetDocument"
    | "obligationDocument"
    | "relatedDocument"
    | "adminFeeType"
    | "distributeAdminFee"
    | "discrepancyResponse";

export type UBLInvoiceAction = {
    titulo: string;
    icono: string;
    visible: boolean;
    evento: () => void;
};

type UBLInvoiceModalKey = UBLInvoiceActionKey | "viewer";

type UBLInvoiceModalConfig = {
    name: string;
    format: string;
    btnSubmit: boolean;
};

const MODAL_CONFIG: Record<UBLInvoiceModalKey, UBLInvoiceModalConfig> = {
    edit: { name: "Editar Factura", format: MODAL_LG, btnSubmit: true },
    items: { name: "Items de la Factura", format: MODAL_XL, btnSubmit: false },
    withholdingTaxes: { name: "Retenciones de la Factura", format: MODAL_XL, btnSubmit: false },
    accountingDocuments: { name: "Ver Documentos Contables", format: MODAL_LG, btnSubmit: false },
    invoiceDocument: { name: "Abrir archivo", format: MODAL_XL, btnSubmit: false },
    payments: { name: "Ver pagos de Factura", format: MODAL_LG, btnSubmit: false },
    events: { name: "Ver eventos en la Factura", format: MODAL_LG, btnSubmit: false },
    crossPrepaid: { name: "Cruzar Anticipo", format: MODAL_md, btnSubmit: true },
    applyPrepaid: { name: "Aplicar Anticipo", format: MODAL_md, btnSubmit: true },
    contingency: { name: "Definir Factura como Contingencia", format: MODAL_md, btnSubmit: true },
    setAsSale: { name: "Definir Factura como Venta", format: MODAL_md, btnSubmit: true },
    proforma: { name: "Generar Factura Proforma", format: MODAL_md, btnSubmit: true },
    description: { name: "Crear/Modificar Objeto de Factura", format: MODAL_md, btnSubmit: true },
    accountantConcept: { name: "Crear/Modificar Concepto de Ingreso", format: MODAL_md, btnSubmit: true },
    paymentTerms: { name: "Terminos de Pago", format: MODAL_md, btnSubmit: true },
    currency: { name: "Especificar Divisa", format: MODAL_md, btnSubmit: true },
    createAccounting: { name: "Generar Causacion Contable", format: MODAL_md, btnSubmit: true },
    fireElectronicDocument: { name: "Transmitir/Descargar Documento", format: MODAL_LG, btnSubmit: true },
    adjustmentNotes: { name: "Notas de Ajuste", format: MODAL_LG, btnSubmit: false },
    radianEvents: { name: "Eventos Radian", format: MODAL_LG, btnSubmit: false },
    duplicate: { name: "Duplicar Factura", format: MODAL_md, btnSubmit: true },
    xml: { name: "Generar Documento XML", format: MODAL_md, btnSubmit: true },
    notifyEmail: { name: "Enviar Notificacion por Email", format: MODAL_md, btnSubmit: true },
    emailRep: { name: "Eventos Correo electronico", format: MODAL_LG, btnSubmit: false },
    notifySiif: { name: "Enviar Notificacion a SIIF", format: MODAL_md, btnSubmit: true },
    fixedAssetEntry: { name: "Generar Entrada Almacen", format: MODAL_LG, btnSubmit: true },
    invoiceAttachment: { name: "Modificar Documento Cargado", format: MODAL_md, btnSubmit: true },
    nullify: { name: "Anular Factura", format: MODAL_LG, btnSubmit: true },
    paymentType: { name: "Editar Tipo de Pago de la Factura", format: MODAL_md, btnSubmit: true },
    accountingDocument: { name: "Ver Documento de Causacion Contable", format: MODAL_md, btnSubmit: false },
    fixedAssetDocument: { name: "Ver Documento de Entrada a Almacen", format: MODAL_md, btnSubmit: false },
    obligationDocument: { name: "Ver Documento de Obligacion Presupuestal", format: MODAL_md, btnSubmit: false },
    relatedDocument: { name: "Documento Relacionado", format: MODAL_LG, btnSubmit: false },
    adminFeeType: { name: "Definir Tipo de Distribucion de AIU", format: MODAL_md, btnSubmit: true },
    distributeAdminFee: { name: "Generar Distribucion de AIU", format: MODAL_md, btnSubmit: true },
    discrepancyResponse: { name: "Definir Tipo de Discrepancia", format: MODAL_md, btnSubmit: true },
    viewer: { name: "Documento", format: MODAL_XL, btnSubmit: false },
};

interface UseUBLInvoiceActionsProps {
    invoice: any;
    actionKeys?: UBLInvoiceActionKey[];
    onChange?: () => void;
    canView?: boolean;
    canDelete?: boolean;
    useSupplierPaymentType?: boolean;
    isCash?: boolean;
    onEdit?: () => void;
}

export const UBL_DOCUMENT_CATALOG_ACTIONS: UBLInvoiceActionKey[] = [
    "edit",
    "items",
    "withholdingTaxes",
    "accountingDocuments",
    "invoiceDocument",
    "payments",
    "events",
    "crossPrepaid",
    "applyPrepaid",
    "contingency",
    "setAsSale",
    "proforma",
    "description",
    "accountantConcept",
    "paymentTerms",
    "currency",
    "createAccounting",
    "fireElectronicDocument",
    "adjustmentNotes",
    "radianEvents",
    "duplicate",
    "xml",
    "notifyEmail",
    "emailRep",
    "notifySiif",
    "fixedAssetEntry",
    "invoiceAttachment",
    "nullify",
    "relatedDocument",
    "adminFeeType",
    "distributeAdminFee",
    "discrepancyResponse",
];


export const useUBLInvoiceActions = ({
    invoice,
    actionKeys = UBL_DOCUMENT_CATALOG_ACTIONS,
    onChange,
    canView = false,
    canDelete = false,
    useSupplierPaymentType = false,
    isCash = false,
    onEdit,
}: UseUBLInvoiceActionsProps) => {
    const ublInvoice = useDataBean(_UBLInvoice);
    const fileService = new FileService();
    const [draftInvoice, setDraftInvoice] = useState<any>({});
    const [observations, setObservations] = useState<string>("");
    const [recordDate, setRecordDate] = useState<any>();
    const [reference, setReference] = useState<string>("");
    const [docDate, setDocDate] = useState<string>("");
    const [newDate, setNewDate] = useState<any>();
    const [duplicateObservation, setDuplicateObservation] = useState<string>("");
    const [businessLine, setBusinessLine] = useState<string>("");
    const [idSoftwareDispatcher, setIdSoftwareDispatcher] = useState<number>();
    const [store, setStore] = useState<number>(null);
    const [ublAdminFeeType, setUBLAdminFeeType] = useState<number>();
    const [documentError, setDocumentError] = useState<any>([]);
    const [document, setDocument] = useState<any>([]);
    const [relatedDocument, setRelatedDocument] = useState<any>(null);

    const [head] = useState<any[]>([
        { title: 'ID Factura', property: 'IDUBLInvoice', visible: true, mask: MASK_NUMBER },
        { title: 'Nit-Cliente', property: 'Client', visible: true },
        { title: 'Cliente', property: 'AccountCustomerName', visible: true },
        { title: 'Tipo UBL', property: 'UBLDocumentTypeName', visible: true },
        { title: 'Nit - Proveedor', property: 'AccountSupplierNit', visible: true },
        { title: 'Proveedor', property: 'AccountSupplierName', visible: true },
        { title: 'No Factura', property: 'InvoiceID', visible: true },
        { title: 'Estado Factura DIAN', property: 'StatusMessage', visible: true },
        { title: 'Trasmitida DIAN', property: 'UBLDispatched', visible: true, mask: MASK_BOOLEAN },
        { title: 'CUFE', property: 'UUID', visible: false },
        { title: 'Documento Relacionado', property: 'DocRelation', visible: true },
        { title: 'es Documento Contigencia?', property: 'IsDocContingency', visible: true },
        { title: 'Documento Contigencia', property: 'DocContigencia', visible: true },
        { title: 'LÃ­neas Factura', property: 'LineCountNumeric', visible: true },
        { title: 'Valor Total', property: 'TotalInvoiceAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuesto', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
        { title: 'Descuentos', property: 'DiscountAmount', visible: true },
        { title: 'Aplicar Anticipo', property: 'ApplyPrepaidValue', visible: true, mask: MASK_BOOLEAN },
        { title: 'Valor del Anticipo', property: 'PrepaidPayment', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Factura', property: 'IssueDate', visible: true, mask: MASK_DATE },
        { title: 'Documento Factura', property: 'Doc', visible: true },
        { title: 'Documento Obligacion', property: 'Obligation', visible: true },
        { title: 'FC', property: 'FCEntity', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Fecha FC', property: 'FCDate', visible: true, mask: MASK_DATE },
        { title: 'Obligacion', property: 'OBEntity', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Fecha Obligacion', property: 'OBDate', visible: true, mask: MASK_DATE },
        { title: 'Entrada de AlmacÃ©n/RemisiÃ³n', property: 'Remision', visible: true },
        { title: 'Entrada Almacen', property: 'EAFMnemonic', visible: false, mask: MASK_DATE },
        { title: 'Consecutivo Entrada', property: 'EAFConsecutive', visible: false },
        { title: 'Fecha Entrada', property: 'EAFDate', visible: false, mask: MASK_DATE },
        { title: 'Fecha Procesamiento', property: 'Since', visible: true, mask: MASK_DATE },
        { title: 'Estado Factura', property: 'DocumentStateName', visible: true },
        { title: 'Tipo Factura', property: 'SourceTypeName', visible: true },
        { title: 'Estado EAF', property: 'EAFDocumentStateName', visible: true },
        { title: 'Estado Salidas', property: 'OutputCostStateName', visible: false },
        { title: 'Documento Soporte', property: 'IsDocumentSupport', visible: true, mask: MASK_BOOLEAN },
        { title: 'Concepto de Ingreso', property: 'AccountantConceptName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Cuenta Puente Ingreso Bienes', property: 'CreditAccountantIDName', visible: true },
        { title: 'Tipo de Pago', property: 'PaymentTypeName', visible: true },
        { title: 'DÃ­as de Vencimiento', property: 'DefeatDays', visible: true },
        { title: 'Calcular Retencion en la Fuente como Empleado', property: 'DoTaxHoldAsEmployee', visible: true },
        { title: 'Definir Base para Retencion de Impuesto', property: 'ApplyTaxHoldBase', visible: true },
        { title: 'Base para Retencion de Impuesto', property: 'TaxHoldBaseValue', visible: true },
        { title: 'Tipo de Impuesto', property: 'TaxEntity', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Utilizar Otra Moneda', property: 'UseOtherCurrency', visible: true },
        { title: 'Moneda de la TransacciÃ³n', property: 'CurrencyName', visible: true },
        { title: 'Tasa de cambio', property: 'ExchangeRate', visible: true },
        { title: 'Pertenece a Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Discrepancia', property: 'UBLDiscrepancyResponseName', visible: true },
        { title: 'Descripcion Discrepancia', property: 'DiscrepancyResponseDescription', visible: true },
    ]);

    const editModal = useModal(MODAL_CONFIG.edit.name, MODAL_CONFIG.edit.format);
    const itemsModal = useModal(MODAL_CONFIG.items.name, MODAL_CONFIG.items.format);
    const withholdingTaxesModal = useModal(MODAL_CONFIG.withholdingTaxes.name, MODAL_CONFIG.withholdingTaxes.format);
    const accountingDocumentsModal = useModal(MODAL_CONFIG.accountingDocuments.name, MODAL_CONFIG.accountingDocuments.format);
    const invoiceDocumentModal = useModal(MODAL_CONFIG.invoiceDocument.name, MODAL_CONFIG.invoiceDocument.format);
    const paymentsModal = useModal(MODAL_CONFIG.payments.name, MODAL_CONFIG.payments.format);
    const eventsModal = useModal(MODAL_CONFIG.events.name, MODAL_CONFIG.events.format);
    const crossPrepaidModal = useModal(MODAL_CONFIG.crossPrepaid.name, MODAL_CONFIG.crossPrepaid.format);
    const applyPrepaidModal = useModal(MODAL_CONFIG.applyPrepaid.name, MODAL_CONFIG.applyPrepaid.format);
    const contingencyModal = useModal(MODAL_CONFIG.contingency.name, MODAL_CONFIG.contingency.format);
    const setAsSaleModal = useModal(MODAL_CONFIG.setAsSale.name, MODAL_CONFIG.setAsSale.format);
    const proformaModal = useModal(MODAL_CONFIG.proforma.name, MODAL_CONFIG.proforma.format);
    const descriptionModal = useModal(MODAL_CONFIG.description.name, MODAL_CONFIG.description.format);
    const accountantConceptModal = useModal(MODAL_CONFIG.accountantConcept.name, MODAL_CONFIG.accountantConcept.format);
    const paymentTermsModal = useModal(MODAL_CONFIG.paymentTerms.name, MODAL_CONFIG.paymentTerms.format);
    const currencyModal = useModal(MODAL_CONFIG.currency.name, MODAL_CONFIG.currency.format);
    const createAccountingModal = useModal(MODAL_CONFIG.createAccounting.name, MODAL_CONFIG.createAccounting.format);
    const fireElectronicDocumentModal = useModal(MODAL_CONFIG.fireElectronicDocument.name, MODAL_CONFIG.fireElectronicDocument.format);
    const adjustmentNotesModal = useModal(MODAL_CONFIG.adjustmentNotes.name, MODAL_CONFIG.adjustmentNotes.format);
    const radianEventsModal = useModal(MODAL_CONFIG.radianEvents.name, MODAL_CONFIG.radianEvents.format);
    const duplicateModal = useModal(MODAL_CONFIG.duplicate.name, MODAL_CONFIG.duplicate.format);
    const xmlModal = useModal(MODAL_CONFIG.xml.name, MODAL_CONFIG.xml.format);
    const notifyEmailModal = useModal(MODAL_CONFIG.notifyEmail.name, MODAL_CONFIG.notifyEmail.format);
    const emailReport = useModal(MODAL_CONFIG.emailRep.name, MODAL_CONFIG.emailRep.format);
    const notifySiifModal = useModal(MODAL_CONFIG.notifySiif.name, MODAL_CONFIG.notifySiif.format);
    const fixedAssetEntryModal = useModal(MODAL_CONFIG.fixedAssetEntry.name, MODAL_CONFIG.fixedAssetEntry.format);
    const invoiceAttachmentModal = useModal(MODAL_CONFIG.invoiceAttachment.name, MODAL_CONFIG.invoiceAttachment.format);
    const nullifyModal = useModal(MODAL_CONFIG.nullify.name, MODAL_CONFIG.nullify.format);
    const paymentTypeModal = useModal(MODAL_CONFIG.paymentType.name, MODAL_CONFIG.paymentType.format);
    const accountingDocumentModal = useModal(MODAL_CONFIG.accountingDocument.name, MODAL_CONFIG.accountingDocument.format);
    const fixedAssetDocumentModal = useModal(MODAL_CONFIG.fixedAssetDocument.name, MODAL_CONFIG.fixedAssetDocument.format);
    const obligationDocumentModal = useModal(MODAL_CONFIG.obligationDocument.name, MODAL_CONFIG.obligationDocument.format);
    const relatedDocumentModal = useModal(MODAL_CONFIG.relatedDocument.name, MODAL_CONFIG.relatedDocument.format);
    const adminFeeTypeModal = useModal(MODAL_CONFIG.adminFeeType.name, MODAL_CONFIG.adminFeeType.format);
    const distributeAdminFeeModal = useModal(MODAL_CONFIG.distributeAdminFee.name, MODAL_CONFIG.distributeAdminFee.format);
    const discrepancyResponseModal = useModal(MODAL_CONFIG.discrepancyResponse.name, MODAL_CONFIG.discrepancyResponse.format);
    const viewerModal = useModal(MODAL_CONFIG.viewer.name, MODAL_CONFIG.viewer.format);

    const modalControls: Record<UBLInvoiceModalKey, ReturnType<typeof useModal>> = {
        edit: editModal,
        items: itemsModal,
        withholdingTaxes: withholdingTaxesModal,
        accountingDocuments: accountingDocumentsModal,
        invoiceDocument: invoiceDocumentModal,
        payments: paymentsModal,
        events: eventsModal,
        crossPrepaid: crossPrepaidModal,
        applyPrepaid: applyPrepaidModal,
        contingency: contingencyModal,
        setAsSale: setAsSaleModal,
        proforma: proformaModal,
        description: descriptionModal,
        accountantConcept: accountantConceptModal,
        paymentTerms: paymentTermsModal,
        currency: currencyModal,
        createAccounting: createAccountingModal,
        fireElectronicDocument: fireElectronicDocumentModal,
        adjustmentNotes: adjustmentNotesModal,
        radianEvents: radianEventsModal,
        duplicate: duplicateModal,
        xml: xmlModal,
        notifyEmail: notifyEmailModal,
        emailRep: emailReport,
        notifySiif: notifySiifModal,
        fixedAssetEntry: fixedAssetEntryModal,
        invoiceAttachment: invoiceAttachmentModal,
        nullify: nullifyModal,
        paymentType: paymentTypeModal,
        accountingDocument: accountingDocumentModal,
        fixedAssetDocument: fixedAssetDocumentModal,
        obligationDocument: obligationDocumentModal,
        relatedDocument: relatedDocumentModal,
        adminFeeType: adminFeeTypeModal,
        distributeAdminFee: distributeAdminFeeModal,
        discrepancyResponse: discrepancyResponseModal,
        viewer: viewerModal,
    };

    useEffect(() => {
        setDraftInvoice(invoice ?? {});
        setUBLAdminFeeType(invoice?.UBLAdminFeeType);
    }, [invoice]);

    const getModal = (key: UBLInvoiceModalKey) => {
        const modal = modalControls[key].modal;
        const config = MODAL_CONFIG[key];
        return {
            ...modal,
            name: modal.name ?? config.name,
            format: modal.format ?? config.format,
            btnClose: modal.btnClose ?? true,
            btnSubmit: config.btnSubmit,
        };
    };

    const updateModal = (key: UBLInvoiceModalKey) => (modal: any) => {
        modalControls[key].setModal(modal);
    };

    const openModal = (key: UBLInvoiceModalKey, name?: string) => {
        const config = MODAL_CONFIG[key];
        modalControls[key].setModal((prev: any) => ({
            ...prev,
            name: name ?? config.name,
            format: config.format,
            btnClose: true,
            btnSubmit: config.btnSubmit,
        }));
        modalControls[key].open(name ?? config.name, config.format);
    };

    const closeModal = (key: UBLInvoiceModalKey) => {
        modalControls[key].close();
    };

    const changeDraft = (property: string, value: any) => {
        setDraftInvoice((prev: any) => ({ ...prev, [property]: value }));
    };

    const notifyChange = () => {
        onChange?.();
    };

    const getProperties = (item: any) => item?.DataBeanProperties ?? item ?? {};

    const validatePrepaid = () => {
        if (!draftInvoice?.ApplyPrepaidValue) return true;

        if (!draftInvoice?.PrepaidIDAccountantStr || draftInvoice.PrepaidIDAccountantStr.trim() === "") {
            toast.error("Debe seleccionar la cuenta contable del anticipo.");
            return false;
        }

        if (!draftInvoice?.PrepaidPayment || isNaN(draftInvoice.PrepaidPayment) || draftInvoice.PrepaidPayment <= 0) {
            toast.error("Debe ingresar un valor valido del anticipo.");
            return false;
        }

        return true;
    };

    const mapDocumentUrls = (resp: any) => {
        const docs: DocumentPDF[] = [];
        if (resp?.DocumentURL) {
            resp.DocumentURL.forEach((element: any) => {
                docs.push({
                    Filename: element.DataBeanProperties.Filename,
                    Media: element.DataBeanProperties.Media,
                    MediaContext: element.DataBeanProperties.MediaContext,
                    Type: element.DataBeanProperties.Type,
                    URLLink: element.DataBeanProperties.URLLink,
                });
            });
        }
        setDocumentError(resp?.MsgList ?? []);
        setDocument(docs);
    };

    const getFileType = (mediaName?: string) => {
        return mediaName?.split(".").pop()?.toLowerCase() ?? "";
    };

    const openViewer = (name: string) => {
        openModal("viewer", name);
    };

    const updateUBLInvoice = (key: UBLInvoiceActionKey) => {
        if (!validatePrepaid()) return;

        ublInvoice.instance.updateUBLInvoice(draftInvoice).then(() => {
            closeModal(key);
            notifyChange();
        }).catch((err: any) => {
            console.log(err);
            toast.error("No se pudo realizar la accion.");
        });
    };

    const updateDescription = () => {
        ublInvoice.instance.setDescriptionToUBLInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, draftInvoice.Description).then(() => {
            closeModal("description");
            notifyChange();
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const updateAccountantConcept = () => {
        ublInvoice.instance.setAccountantConceptToUBLInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, draftInvoice.IDAccountantConcept).then(() => {
            closeModal("accountantConcept");
            notifyChange();
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const applyPrepaidPayment = () => {
        if (!validatePrepaid()) return;

        ublInvoice.instance.applyPrepaidPayment(
            draftInvoice.IDUBLInvoice,
            draftInvoice.IssueDate,
            draftInvoice.ApplyPrepaidValue,
            draftInvoice.ApplyPrepaidValue ? draftInvoice.PrepaidIDAccountantStr : null,
            draftInvoice.ApplyPrepaidValue ? draftInvoice.PrepaidPayment : null
        ).then(() => {
            closeModal("crossPrepaid");
            notifyChange();
        }).catch((err: any) => {
            console.log(err);
            toast.error("No se pudo realizar la accion.");
        });
    };

    const nullifyUBLInvoice = () => {
        ublInvoice.instance.nullifyUBLInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, _single.getAccountID(), observations).then(
            (resp: any) => {
                closeModal("nullify");
                notifyChange();
                if (resp.length > 0) {
                    resp.map((e: any) => toast.info(e, { autoClose: false }));
                } else {
                    toast.error("No se ha podido anular la factura.");
                }
            }
        ).catch((err: any) => {
            console.log(err);
        });
    };

    const setUBLContingency = () => {
        if (!reference) {
            toast.error("Referencia es obligatoria");
            return;
        }
        ublInvoice.instance.setUBLInvoiceAsContingency(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, docDate, reference, _single.getAccountID()).then(() => {
            closeModal("contingency");
            notifyChange();
        }).catch((err: any) => { toast.error(err) });
    };

    const setUBLSales = () => {
        ublInvoice.instance.setUBLInvoiceContingencyAsSalesInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, _single.getAccountID()).then(() => {
            closeModal("setAsSale");
            notifyChange();
        }).catch((err: any) => { toast.error(err) });
    };

    const createDuplicateUBL = () => {
        if (!newDate || !duplicateObservation) {
            toast.error("Los campos son obligatorios");
            return;
        }
        ublInvoice.instance.duplicateUBLInvoice(newDate, draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, duplicateObservation, _single.getAccountID()).then(() => {
            setNewDate(null);
            setDuplicateObservation("");
            closeModal("duplicate");
            notifyChange();
        }).catch((err: any) => { toast.error(err) });
    };

    const getXML = () => {
        if (!idSoftwareDispatcher) {
            toast.error("Debe seleccionar el software de facturacion.");
            return;
        }

        ublInvoice.instance.getUBLInvoiceXml(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, _single.getAccountID(), idSoftwareDispatcher).then((resp: any) => {
            setDocument([{
                Filename: resp.Filename,
                Media: resp.Media,
                MediaContext: resp.MediaContext,
                Type: resp.Type,
                URLLink: resp.URLLink,
            }]);
            closeModal("xml");
            openViewer("Documento XML");
        }).catch((err: any) => { toast.error(err) });
    };

    const getElectronicDocumentProforma = () => {
        const idUBLSoftwareDispatcher = idSoftwareDispatcher;

        if (!idUBLSoftwareDispatcher) {
            toast.error("Debe seleccionar el software de facturacion.");
            return;
        }

        ublInvoice.instance.getElectronicDocumentProforma(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, _single.getAccountID(), idUBLSoftwareDispatcher).then((resp: any) => {
            console.log("RESP:", resp);

            const data = resp;

            if (!data?.MediaContext || !data?.Media) {
                console.warn("No viene MediaContext o Media");
                toast.error("No se encontro el documento para visualizar");
                return;
            }

            const proformaDocument = {
                Filename: data.Filename ?? data.Media,
                Media: data.Media,
                MediaContext: data.MediaContext,
                Type: data.Type ?? getFileType(data.Media),
                URLLink: data.URLLink ?? fileService.getUrlFile(data.MediaContext, data.Media),
            };

            setDocumentError([]);
            setDocument([proformaDocument]);

            closeModal("proforma");
            setTimeout(() => {
                openViewer("Factura Proforma");
            }, 100);
        }).catch((err: any) => {
            console.error(err);
            toast.error(err);
        });
    };

    const getRelatedDocumentOwner = () => {
        ublInvoice.instance.getUBLInvoiceOwner(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate).then((resp: any) => {
            const data = getProperties(resp);

            if (!data || Object.keys(data).length === 0) {
                toast.info("No se encontro documento relacionado.");
                return;
            }

            setRelatedDocument(resp);
            openModal("relatedDocument");
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const setUBLDiscrepancyResponse = () => {
        const description = draftInvoice?.DiscrepancyResponseDescription ?? "";

        if (!draftInvoice?.IDUBLDiscrepancyResponse) {
            toast.error("Debe seleccionar la discrepancia.");
            return;
        }

        if (description.trim().length === 0) {
            toast.error("La descripcion es obligatoria.");
            return;
        }

        ublInvoice.instance.setUBLDiscrepancyResponse(
            draftInvoice.IDUBLInvoice,
            draftInvoice.IssueDate,
            draftInvoice.IDUBLDiscrepancyResponse,
            description
        ).then(() => {
            closeModal("discrepancyResponse");
            notifyChange();
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const setUBLAdminFeeTypeToUBLInvoice = () => {
        if (ublAdminFeeType === null || ublAdminFeeType === undefined) {
            toast.error("Debe seleccionar el tipo de distribucion.");
            return;
        }

        ublInvoice.instance.setUBLAdminFeeTypeToUBLInvoice(
            draftInvoice.IDUBLInvoice,
            draftInvoice.IssueDate,
            ublAdminFeeType
        ).then(() => {
            setDraftInvoice((prev: any) => ({ ...prev, UBLAdminFeeType: ublAdminFeeType }));
            closeModal("adminFeeType");
            notifyChange();
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const distributeAdminFeeValue = () => {
        if (ublAdminFeeType === null || ublAdminFeeType === undefined) {
            toast.error("Debe seleccionar el tipo de distribucion.");
            return;
        }

        ublInvoice.instance.distributeAdminFeeValue(
            draftInvoice.IDUBLInvoice,
            draftInvoice.IssueDate,
            ublAdminFeeType
        ).then((resp: any) => {
            closeModal("distributeAdminFee");
            notifyChange();
            if (resp === true) {
                toast.success("Distribucion de AIU generada.");
            } else {
                toast.error("No se pudo generar la distribucion de AIU.");
            }
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const notifyInvoiceEmail = () => {
        const props = {
            message: observations,
        };

        ublInvoice.instance.notifyInvoiceEmail(_single.getAccountID(), draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, props).then((resp: any) => {
            if (resp.OK) {
                toast.success(resp.OK);
            } else if (resp.ERR) {
                toast.warning(resp.ERR);
            } else {
                toast.error("");
            }

            closeModal("notifyEmail");
            setObservations("");
            notifyChange();
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const notifyInvoiceSiif = () => {
        if (businessLine.trim().length === 0) {
            toast.error("Linea de Negocio es Requerido");
            return;
        }

        const props = {
            message: observations,
            BusinessLine: businessLine,
        };

        ublInvoice.instance.notifyInvoiceSIIFByEmail(_single.getAccountID(), draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, props).then((resp: any) => {
            if (resp.OK) {
                toast.success(resp.OK);
            } else if (resp.ERR) {
                toast.warning(resp.ERR);
            }

            closeModal("notifySiif");
            setObservations("");
            setBusinessLine("");
            notifyChange();
        }).catch((err: any) => {
            toast.error(err);
        });
    };

    const createAccountantDocumentForUBLInvoice = () => {
        ublInvoice.instance.createAccountantDocumentForUBLInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, recordDate, _single.getAccountID()).then((resp: any) => {
            mapDocumentUrls(resp);
            closeModal("createAccounting");
            openViewer("Causacion Contable");
            notifyChange();
        }).catch((err: any) => toast.error(err));
    };

    const generateEntry = () => {
        if (store == null || store == undefined || isNaN(store)) {
            toast.error("Debe Seleccionar un almacen");
            return;
        }
        ublInvoice.instance.createFixedAssetEntryForUBLInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, _single.getCurrenDate(), store, _single.getAccountID()).then((resp: any) => {
            mapDocumentUrls(resp);
            closeModal("fixedAssetEntry");
            openViewer("Documento de Entrada");
            notifyChange();
        }).catch((err: any) => {
            console.error(err);
            toast.error("No se Pudo Realizar la Accion");
        });
    };

    const getAccountantDoc = () => {
        ublInvoice.instance.getAccountantDocumentForInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, _single.getAccountID()).then((resp: any) => {
            mapDocumentUrls(resp);
            openViewer("Documento de Causacion Contable");
        }).catch((err: any) => toast.error(err));
    };

    const getFixedDoc = () => {
        ublInvoice.instance.getFixedAssetEntryForInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, _single.getAccountID()).then((resp: any) => {
            mapDocumentUrls(resp);
            openViewer("Documento de Entrada a Almacen");
        }).catch((err: any) => toast.error(err));
    };

    const getObligationDoc = () => {
        ublInvoice.instance.getObligationDocumentForInvoice(draftInvoice.IDUBLInvoice, draftInvoice.IssueDate, _single.getAccountID()).then((resp: any) => {
            mapDocumentUrls(resp);
            openViewer("Documento de Obligacion Presupuestal");
        }).catch((err: any) => toast.error(err));
    };

    const openActionModal = (key: UBLInvoiceActionKey) => {
        const dynamicName = key === "withholdingTaxes"
            ? `${MODAL_CONFIG.withholdingTaxes.name} ${draftInvoice.IDUBLInvoice ?? ""}`.trim()
            : undefined;
        openModal(key, dynamicName);
    };

    const actions = useMemo(() => {
        const isPurchaseOrSaleDocument = draftInvoice?.UBLDocumentType == PURCHASE_INVOICE || draftInvoice?.UBLDocumentType == BILL_OF_SALE;
        const isSaleDocument = draftInvoice?.UBLDocumentType === BILL_OF_SALE;
        const isContingencyDocument = draftInvoice?.UBLDocumentType == BILL_OF_SALE_CONTINGENCY;

        const createAction = (key: UBLInvoiceActionKey, titulo: string, icono: string, visible: boolean, event?: () => void): UBLInvoiceAction => ({
            titulo,
            icono,
            visible,
            evento: event ?? (() => openActionModal(key)),
        });

        const actionCatalog: Record<UBLInvoiceActionKey, UBLInvoiceAction> = {
            edit: createAction("edit", "Editar", "ri-edit-line", true, onEdit),
            items: createAction("items", "Ver Items de la Factura", "ri-list-ordered", true),
            withholdingTaxes: createAction("withholdingTaxes", "Ver Retenciones de la Factura", "ri-list-ordered", true),
            accountingDocuments: createAction("accountingDocuments", "Ver Documentos Contables", "ri-list-ordered", true),
            invoiceDocument: createAction("invoiceDocument", "Ver Documento de Factura", "ri-file-list-line", true),
            payments: createAction("payments", "Ver pagos de Factura", "ri-list-ordered", true),
            events: createAction("events", "Ver eventos en la Factura", "ri-history-line", true),
            crossPrepaid: createAction("crossPrepaid", "Cruzar Anticipo", "ri-swap-box-line", isSaleDocument),
            applyPrepaid: createAction("applyPrepaid", "Aplicar Anticipo", "ri-money-dollar-circle-line", draftInvoice?.ApplyPrepaidValue === true && isSaleDocument),
            contingency: createAction("contingency", "Relacionar Factura de Papel/Contingencia", "ri-swap-box-line", isSaleDocument),
            setAsSale: createAction("setAsSale", "Definir Factura como Venta", "ri-swap-box-line", isContingencyDocument),
            proforma: createAction("proforma", "Generar Factura Proforma", "ri-swap-box-line", true),
            description: createAction("description", "Crear/Modificar Objeto de Factura", "ri-file-list-line", true),
            accountantConcept: createAction("accountantConcept", "Crear/Modificar Concepto de Ingreso", "ri-file-list-line", true),
            paymentTerms: createAction("paymentTerms", "Terminos de Pago", "ri-money-dollar-box-line", true),
            currency: createAction("currency", "Especificar Divisa", "ri-money-dollar-box-line", true),
            createAccounting: createAction("createAccounting", "Generar Causacion Contable", "ri-save-line", true),
            fireElectronicDocument: createAction("fireElectronicDocument", "Transmitir/Descargar Documento Electronico", "ri-list-ordered", true),
            adjustmentNotes: createAction("adjustmentNotes", "Notas de Ajuste", "ri-list-check", isPurchaseOrSaleDocument),
            radianEvents: createAction("radianEvents", "Eventos Radian", "ri-list-check", canView && (isPurchaseOrSaleDocument || useSupplierPaymentType)),
            duplicate: createAction("duplicate", "Duplicar Documento", "ri-list-check", canView),
            xml: createAction("xml", "Generar Xml del Documento", "ri-list-check", canView),
            notifyEmail: createAction("notifyEmail", "Enviar Notificacion por Email", "ri-mail-send-line", canView),
            emailRep: createAction("emailRep", "Eventos Correo electronico", "ri-mail-line", canView && isSaleDocument),
            notifySiif: createAction("notifySiif", "Enviar Notificacion a SIIF", "ri-send-plane-line", canView),
            fixedAssetEntry: createAction("fixedAssetEntry", "Generar Entrada a Activos Fijos", "ri-save-line", isSaleDocument),
            invoiceAttachment: createAction("invoiceAttachment", "Agregar/Modificar Documento de Factura", "ri-swap-line", true),
            nullify: createAction("nullify", "Anular", "ri-forbid-line", canDelete),
            paymentType: createAction("paymentType", "Modificar Tipo de Pago", "ri-edit-2-line", true),
            accountingDocument: createAction("accountingDocument", "Ver Documento de Causacion Contable", "ri-save-line", true),
            fixedAssetDocument: createAction("fixedAssetDocument", "Ver Documento de Entrada a Almacen", "ri-save-line", true),
            obligationDocument: createAction("obligationDocument", "Ver Documento de Obligacion Presupuestal", "ri-save-line", Boolean(draftInvoice?.OBConsecutive)),
            relatedDocument: createAction("relatedDocument", "Consultar Documento Relacionado", "ri-file-search-line", canView, getRelatedDocumentOwner),
            adminFeeType: createAction("adminFeeType", "Definir Tipo de Distribucion de AIU", "ri-percent-line", true),
            distributeAdminFee: createAction("distributeAdminFee", "Generar Distribucion de AIU", "ri-calculator-line", true),
            discrepancyResponse: createAction("discrepancyResponse", "Definir Tipo de Discrepancia", "ri-error-warning-line", canView),
        };

        return actionKeys.map((key) => actionCatalog[key]);
    }, [actionKeys, canDelete, canView, draftInvoice, onEdit, useSupplierPaymentType]);

    const listButtons = useMemo(() => <ListMenu listaBotones={actions} />, [actions]);

    const renderInvoiceDocument = () => {
        const fileType = draftInvoice?.Media?.split(".").pop();
        const downloadURL = fileService.getUrlFile(draftInvoice?.MediaContext, draftInvoice?.Media);

        if (!fileType) return <>No se pudo cargar el Documento</>;

        if (fileType === "pdf") {
            return <iframe name="pdfviwer" src={downloadURL} onError={(e) => console.error("Error loading PDF:", e)} />;
        }

        if (fileType === "jpg" || fileType === "png") {
            return <img src={downloadURL} alt="Image Preview" width="100%" />;
        }

        return (
            <Alert clase="primary">
                <a href={downloadURL} target="_blank">{draftInvoice?.Doc ?? "Documento"}</a>
            </Alert>
        );
    };

    const renderRelatedDocument = () => {
        const data = getProperties(relatedDocument);
        const fields = [
            { label: "ID Factura", value: data.IDUBLInvoice },
            { label: "No Factura", value: data.InvoiceID },
            { label: "Fecha Factura", value: data.IssueDate },
            { label: "Tipo UBL", value: data.UBLDocumentTypeName },
            { label: "Proveedor", value: data.AccountSupplierName },
            { label: "Cliente", value: data.AccountCustomerName },
            { label: "Valor Total", value: data.TotalInvoiceAmount },
            { label: "Estado", value: data.DocumentStateName ?? data.StateName },
        ].filter((field) => field.value !== undefined && field.value !== null && field.value !== "");

        if (fields.length === 0) {
            return <pre className="mb-0">{JSON.stringify(data, null, 2)}</pre>;
        }

        return (
            <div className="row">
                {fields.map((field) => (
                    <div className="col-md-6 mb-2" key={field.label}>
                        <strong>{field.label}: </strong>
                        <span>{field.value}</span>
                    </div>
                ))}
            </div>
        );
    };
    //modales de uso

    const actionModals = (
        <>

            <Modal modal={getModal("edit")} updateModal={updateModal("edit")} eventModal={() => updateUBLInvoice("edit")} >
                <div className="row">
                    <div className="col-md-12">
                        <label>No Factura</label>
                        <input type="text" className="form-control" value={draftInvoice?.InvoiceID ?? ""} onChange={(e) => changeDraft("InvoiceID", e.target.value)} />
                    </div>
                    <div className="col-md-12">
                        <FileInput onCreate={(e) => setDraftInvoice((prev: any) => ({ ...prev, Media: e.Media, MediaContext: e.MediaContext }))} Media={draftInvoice?.Media} MediaContext={draftInvoice?.MediaContext} label={draftInvoice?.Media ? "Documento de la Factura Cargada" : "Cargar Documento de Factura"} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("items")} updateModal={updateModal("items")} >
                {useSupplierPaymentType ?
                    <UBLInvoiceItemSupplier ublInvoce={draftInvoice} idUBLInvoice={draftInvoice?.IDUBLInvoice} issueDate={draftInvoice?.IssueDate} isCash={isCash} _onChange={notifyChange} />
                    :
                    <CreateUBLInvoiceItems idUBLInvoice={draftInvoice?.IDUBLInvoice} issueDate={draftInvoice?.IssueDate} _onChange={notifyChange} />
                }
            </Modal>

            <Modal modal={getModal("withholdingTaxes")} updateModal={updateModal("withholdingTaxes")} >
                <UBLInvoiceTaxSupplier updateLista={notifyChange} idublInvoice={draftInvoice?.IDUBLInvoice} issueDate={draftInvoice?.IssueDate} />
            </Modal>

            <Modal modal={getModal("accountingDocuments")} updateModal={updateModal("accountingDocuments")} >
                <AccountantDocumentList _idUBLInvoice={draftInvoice?.IDUBLInvoice} _isseDate={draftInvoice?.IssueDate} />
            </Modal>

            <Modal modal={getModal("invoiceDocument")} updateModal={updateModal("invoiceDocument")} >
                {renderInvoiceDocument()}
            </Modal>

            <Modal modal={getModal("payments")} updateModal={updateModal("payments")} >
                <UBLPayment idUBLInvoice={draftInvoice?.IDUBLInvoice} issueDate={draftInvoice?.IssueDate} />
            </Modal>

            <Modal modal={getModal("emailRep")} updateModal={updateModal("emailRep")} >
                <UBLEventsInvoiceEmail idUBLInvoice={draftInvoice?.IDUBLInvoice} />
            </Modal>

            <Modal modal={getModal("events")} updateModal={updateModal("events")} >
                <HistoryUBLInvoice _idUBLInvoice={draftInvoice?.IDUBLInvoice} _isseDate={draftInvoice?.IssueDate} />
            </Modal>

            <Modal modal={getModal("fireElectronicDocument")} updateModal={updateModal("fireElectronicDocument")} evenOnClose={notifyChange} >
                <FireElectronicDocument _idUBLInvoice={draftInvoice?.IDUBLInvoice} _isseDate={draftInvoice?.IssueDate} _obs={draftInvoice?.Description ?? ""} _refresh={notifyChange} />
            </Modal>

            <Modal modal={getModal("adjustmentNotes")} updateModal={updateModal("adjustmentNotes")} evenOnClose={notifyChange} >
                <UBLInvoiceAdjustment ublInvoice={draftInvoice} />
            </Modal>

            <Modal modal={getModal("radianEvents")} updateModal={updateModal("radianEvents")} >
                <UBLNotification ublInvoice={draftInvoice} />
            </Modal>

            <Modal modal={getModal("description")} updateModal={updateModal("description")} eventModal={updateDescription} >
                <textarea className="form-control" value={draftInvoice?.Description ?? ""} onChange={(e) => changeDraft("Description", e.target.value)} />
            </Modal>

            <Modal modal={getModal("accountantConcept")} updateModal={updateModal("accountantConcept")} eventModal={updateAccountantConcept} >
                <div className="row">
                    {draftInvoice?.UBLDocumentType == BILL_OF_SALE &&
                        <div className="col-md-12">
                            <label>Concepto de Ingreso de Facturacion de Venta</label>
                            <SelectAccountantConceptCatalogForSalesInvoice label=" " idSelector={draftInvoice?.IDAccountantConcept} onChange={(e) => changeDraft("IDAccountantConcept", e)} />
                        </div>
                    }
                    {draftInvoice?.UBLDocumentType == PURCHASE_INVOICE &&
                        <div className="col-md-12">
                            <label>Concepto de Ingreso de Facturacion Proveedor</label>
                            <SelectAccountantConceptCatalogForSupplierInvoice label=" " idSelector={draftInvoice?.IDAccountantConcept} onChange={(e) => changeDraft("IDAccountantConcept", e)} />
                        </div>
                    }
                </div>
            </Modal>

            <Modal modal={getModal("invoiceAttachment")} updateModal={updateModal("invoiceAttachment")} eventModal={() => updateUBLInvoice("invoiceAttachment")} >
                <div className="row">
                    <div className="col-md-12">
                        <label>No Factura</label>
                        <input type="text" className="form-control" value={draftInvoice?.InvoiceID ?? ""} onChange={(e) => changeDraft("InvoiceID", e.target.value)} />
                    </div>
                    <div className="col-md-12">
                        <FileInput onCreate={(e) => setDraftInvoice((prev: any) => ({ ...prev, Media: e.Media, MediaContext: e.MediaContext }))} Media={draftInvoice?.Media} MediaContext={draftInvoice?.MediaContext} label={draftInvoice?.Media ? "Documento de la Factura Cargada" : "Cargar Documento de Factura"} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("crossPrepaid")} updateModal={updateModal("crossPrepaid")} eventModal={applyPrepaidPayment} >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Aplicar Anticipo" estado={draftInvoice?.ApplyPrepaidValue} eventChange={(e) => changeDraft("ApplyPrepaidValue", e)} />
                    </div>
                    <div className="col-md-12">
                        <PrepaidPaymentEditor _Invoice={draftInvoice} onChange={(e) => changeDraft("PrepaidIDAccountantStr", e.JsonCode)} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _value={draftInvoice?.PrepaidPayment} onChange={(e) => changeDraft("PrepaidPayment", e)} _label="Valor del Anticipo a Cruzar" />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("applyPrepaid")} updateModal={updateModal("applyPrepaid")} eventModal={() => updateUBLInvoice("applyPrepaid")} >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Aplicar Anticipo" estado={draftInvoice?.ApplyPrepaidValue} eventChange={(e) => changeDraft("ApplyPrepaidValue", e)} />
                    </div>
                    <div className="col-md-12">
                        <ReciablePaymentEditor renderValue={draftInvoice?.PrepaidIDAccountantStr} _Invoice={draftInvoice} onChange={(e) => changeDraft("PrepaidIDAccountantStr", e.JsonCode)} />
                    </div>
                    <div className="col-md-12">
                        <InputMoney _value={draftInvoice?.PrepaidPayment} onChange={(e) => changeDraft("PrepaidPayment", e)} _label="Valor del Anticipo a Cruzar" />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("currency")} updateModal={updateModal("currency")} eventModal={() => updateUBLInvoice("currency")} >
                <div className="row">
                    <div className="col-md-12">
                        <BasicSwitch label="Utilizar Otra Moneda" estado={draftInvoice?.UseOtherCurrency} eventChange={(e) => changeDraft("UseOtherCurrency", e)} />
                    </div>
                    {draftInvoice?.UseOtherCurrency &&
                        <>
                            <div className="col-md-12">
                                <CurrencyEditor id={draftInvoice?.IDCurrency} onchange={(e) => changeDraft("IDCurrency", e)} />
                            </div>
                            <div className="col-md-12">
                                <label>Tasa de cambio</label>
                                <input type="number" className="form-control" value={draftInvoice?.ExchangeRate ?? ""} onChange={(e) => changeDraft("ExchangeRate", e.target.value ? parseFloat(e.target.value) : null)} />
                            </div>
                        </>
                    }
                </div>
            </Modal>

            <Modal modal={getModal("paymentTerms")} updateModal={updateModal("paymentTerms")} eventModal={() => updateUBLInvoice("paymentTerms")} >
                <div className="row">
                    <div className="col-md-12">
                        <SelectUBLDocumentPaymentType idSelector={draftInvoice?.PaymentType} label="Tipo de Pago" onChange={(e) => changeDraft("PaymentType", e)} />
                    </div>
                    <div className="col-md-12">
                        <label>Dias de Vencimiento</label>
                        <input type="number" className="form-control" value={draftInvoice?.DefeatDays ?? ""} onChange={(e) => changeDraft("DefeatDays", e.target.value ? Number(e.target.value) : null)} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("paymentType")} updateModal={updateModal("paymentType")} eventModal={() => updateUBLInvoice("paymentType")} >
                <div className="col-md-12">
                    <label>Tipo de Pago</label>
                    {useSupplierPaymentType ?
                        <SelectSupplierPaymentTypeConstants idSelector={draftInvoice?.PaymentType} onChange={(e) => changeDraft("PaymentType", e)} label=" " />
                        :
                        <SelectUBLDocumentPaymentType idSelector={draftInvoice?.PaymentType} label=" " onChange={(e) => changeDraft("PaymentType", e)} />
                    }
                </div>
            </Modal>

            <Modal modal={getModal("nullify")} updateModal={updateModal("nullify")} eventModal={nullifyUBLInvoice} >
                <div className="row">
                    <div className="col-md-6">
                        <strong>ID Factura </strong><small>{draftInvoice?.IDUBLInvoice}</small>
                    </div>
                    <div className="col-md-6">
                        <strong>Fecha Factura </strong><small>{draftInvoice?.IssueDate}</small>
                    </div>
                    <div className="col-md-12">
                        <label>Justificacion</label>
                        <textarea className="form-control" value={observations} onChange={(e) => setObservations(e.target.value)} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("contingency")} updateModal={updateModal("contingency")} eventModal={setUBLContingency} >
                <div className="row">
                    <div className="col-md-12">
                        <label>Fecha de Documento de Contingencia</label>
                        <InputDate name="" value={docDate} setDate={(e) => setDocDate(e)} />
                    </div>
                    <div className="col-md-12">
                        <label>Numero de Factura en Papel</label>
                        <input type="text" className="form-control" value={reference} onChange={(e) => setReference(e.target.value)} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("setAsSale")} updateModal={updateModal("setAsSale")} eventModal={setUBLSales} >
                <p>Confirmar definir factura como factura de venta</p>
            </Modal>

            <Modal modal={getModal("duplicate")} updateModal={updateModal("duplicate")} eventModal={createDuplicateUBL}>
                <div className="row">
                    <div className="col-md-12">
                        <InputDate label="Fecha de Factura" name="NewDate" value={newDate} setDate={(e) => setNewDate(e)} />
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>
                        <textarea className="form-control" value={duplicateObservation} onChange={(e) => setDuplicateObservation(e.target.value)} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("xml")} updateModal={updateModal("xml")} eventModal={getXML}>
                <SelectUBLSoftwareDispatcherByEnvironmentType idSelector={idSoftwareDispatcher} onChange={(e) => setIdSoftwareDispatcher(e)} label="Software de Facturacion" />
            </Modal>

            <Modal modal={getModal("proforma")} updateModal={updateModal("proforma")} eventModal={getElectronicDocumentProforma}  >
                <div className="row">
                    <div className="col-md-12">
                        <SelectUBLSoftwareDispatcherByEnvironmentType idSelector={idSoftwareDispatcher} onChange={(e) => setIdSoftwareDispatcher(e)} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("relatedDocument")} updateModal={updateModal("relatedDocument")}>
                {relatedDocument ? renderRelatedDocument() : <Alert clase="primary">No se encontro documento relacionado.</Alert>}
            </Modal>

            <Modal modal={getModal("adminFeeType")} updateModal={updateModal("adminFeeType")} eventModal={setUBLAdminFeeTypeToUBLInvoice}>
                <SelectorUBLAdminFeeTypeConstants idSelector={ublAdminFeeType} onChange={(e) => setUBLAdminFeeType(e)} />
            </Modal>

            <Modal modal={getModal("distributeAdminFee")} updateModal={updateModal("distributeAdminFee")} eventModal={distributeAdminFeeValue}>
                <SelectorUBLAdminFeeTypeConstants idSelector={ublAdminFeeType} onChange={(e) => setUBLAdminFeeType(e)} />
            </Modal>

            <Modal modal={getModal("discrepancyResponse")} updateModal={updateModal("discrepancyResponse")} eventModal={setUBLDiscrepancyResponse}>
                <div className="row">
                    <div className="col-md-12">
                        <EditorUBLDiscrepancyResponse
                            idSelector={draftInvoice?.IDUBLDiscrepancyResponse}
                            label="Discrepancia"
                            onChange={(e) => {
                                const data = getProperties(e);
                                changeDraft("IDUBLDiscrepancyResponse", data.IDUBLDiscrepancyResponse);
                            }}
                        />
                    </div>
                    <div className="col-md-12">
                        <label>Descripcion</label>
                        <textarea
                            className="form-control"
                            value={draftInvoice?.DiscrepancyResponseDescription ?? ""}
                            onChange={(e) => changeDraft("DiscrepancyResponseDescription", e.target.value)}
                        />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("notifyEmail")} updateModal={updateModal("notifyEmail")} eventModal={notifyInvoiceEmail}>
                <div className="row">
                    <div className="col-md-12">
                        <label>Mensaje</label>
                        <textarea className="form-control" value={observations} onChange={(e) => setObservations(e.target.value)} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("notifySiif")} updateModal={updateModal("notifySiif")} eventModal={notifyInvoiceSiif}>
                <div className="row">
                    <div className="col-md-12">
                        <label>Linea de Negocio</label>
                        <input type="text" className="form-control" value={businessLine} onChange={(e) => setBusinessLine(e.target.value)} />
                    </div>
                    <div className="col-md-12">
                        <label>Mensaje</label>
                        <textarea className="form-control" value={observations} onChange={(e) => setObservations(e.target.value)} />
                    </div>
                </div>
            </Modal>

            <Modal modal={getModal("createAccounting")} updateModal={updateModal("createAccounting")} eventModal={createAccountantDocumentForUBLInvoice} onSubmitLabel="Procesar">
                <InputDate label="Fecha de registro contable" name="date" value={recordDate} setDate={setRecordDate} />
            </Modal>

            <Modal modal={getModal("fixedAssetEntry")} updateModal={updateModal("fixedAssetEntry")} onSubmitLabel="Generar Entrada" eventModal={generateEntry}>
                <SelectStoreEditor idSelector={store} onChange={(e) => setStore(e.IDStore)} />
            </Modal>

            <Modal modal={getModal("accountingDocument")} updateModal={updateModal("accountingDocument")}>
                <button type="button" className="btn btn-primary" onClick={getAccountantDoc}>Ver documento</button>
            </Modal>

            <Modal modal={getModal("fixedAssetDocument")} updateModal={updateModal("fixedAssetDocument")}>
                <button type="button" className="btn btn-primary" onClick={getFixedDoc}>Ver documento</button>
            </Modal>

            <Modal modal={getModal("obligationDocument")} updateModal={updateModal("obligationDocument")}>
                <button type="button" className="btn btn-primary" onClick={getObligationDoc}>Ver documento</button>
            </Modal>

            <Modal modal={getModal("viewer")} updateModal={updateModal("viewer")} >
                {documentError.length > 0 ?
                    <ul className="group-list">
                        {documentError.map((item: any, index: number) => <li key={index} className="group-list-item">{item}</li>)}
                    </ul>
                    :
                    <>
                        {document.length > 0 && <DocumentViewer list={document} />}
                    </>
                }
            </Modal>
        </>
    );

    return { actions, listButtons, actionModals, head };
};
